<template>
  <!-- メイン画面 -->
  <div class="content-wrapper">
    <DbsReservationStatusButtons v-if="isReadyToDraw" :park="park" />

    <TemplateDbsIndex v-if="isReadyToDraw" />

    <!-- index画面の描画ローディング -->
    <ItemDialogForIndexPage v-else />
  </div>
  <!-- メイン画面 -->
</template>

<script>
import { onMounted, ref, computed } from "vue";
import { useStore } from "vuex";
import TemplateDbsIndex from "@/views/Templates/Dbs/TemplateDbsIndex";
import dbsService from "@/services/dbs";

import storeJS from "@/store";
import nativeHandlerService from "@/services/nativeHandler";

window.jcSetDbsShareInfo = function (info) {
  const storeParkData = storeJS.getters["dbs/park"];
  if (storeParkData == null) {
    storeJS.commit("dbs/setPark", info);
  } else {
    storeJS.commit("dbs/setPark", {
      ...storeParkData,
      ...info,
    });
  }
};

export default {
  name: "DbsIndex",
  components: {
    TemplateDbsIndex,
  },
  setup() {
    const store = useStore();
    const isReadyToDraw = ref(false);

    const park = computed(() => store.getters["dbs/park"]);

    onMounted(async () => {
      // 開発ブラウザではMixwayAPIでロケーション情報取得
      if (store.getters["common/device"] == "BROWSER") {
        await dbsService.getDBSCyclePortInfoFromMixway();
      } else {
        // ページ描画完了をマップWebviewへ知らせる関数
        nativeHandlerService.ncPageReady();
      }

      isReadyToDraw.value = true;
    });

    return {
      isReadyToDraw,
      park,
    };
  },
};
</script>
